import React, { useState, useEffect } from 'react';
import {
  makeStyles,
  TextField,
} from '@material-ui/core';
import {
  Card,
  CardContent,
  CardActions,
  Grid,
  Typography,

  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  TableContainer,
  Paper,
} from '@mui/material';


import numeral from 'numeral';


import firebase from '../../Firebase';
import { getDatabase, ref, onValue, get, child } from 'firebase/database';

import i18n from 'i18n/i18n';  // i18n 객체 직접 import
import 'intl-pluralrules';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';


const COLUMN_WIDTH = {
  LABEL: '14%',
  VGI: '6%',  //20
  CUR_POWER: '15%',
  CUMULATIVE_POWER: "15%", //50
  SOC: "15%",
  REMAIN_POWER: "15%",
  REMAIN_TIME: "15%", //95
}



const CHGRStatusTable = props => {
  const { className, label, ...rest } = props;
  const classes = useStyles();


  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);


  const database = getDatabase();
  const dbRef = ref(database);



  const handlePageChange = (event, page) => {
    setPage(page);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(event.target.value);
  };

  const startRow = (page * rowsPerPage);


  const [viewData, setViewData] = useState([]);

  // const makeSampleData = () => {

  //   let listData = [];
  //   for (var i = 0; i<12; i++){
  //     listData.push({ label: 'CHGR_' + String(i + 1).padStart(2, '0'),
  //                    cur_supply: (100 * Math.random()).toFixed(1),
  //                   accu_supply: (300 * Math.random()).toFixed(1),
  //                 remaining_charging: (500 * Math.random()).toFixed(1),
  //               battery_avail: (1000 * Math.random()).toFixed(1)});
  //   }
  //   setViewData(listData);
  // }


  const makeSampleData2 = () => {

    onValue(child(dbRef, 'simu/summary/chgr'), (snapshot) => {

      let listData = [];

      snapshot.forEach(function (childSnapshot) {
        listData.push({
          label: childSnapshot.val().chgr_id,
          VGI: childSnapshot.val().vgi_member || 'N',
          cur_supply: childSnapshot.val().charging,
          diff_cur_supply: childSnapshot.val().diff_charging,

          // cumulative_charging
          // diff_cumulative
          cumulative_supply: childSnapshot.val().cumulative_charging,
          diff_cumulative: childSnapshot.val().diff_cumulative,

          remaining_charging: childSnapshot.val().remaining_charging,

          // accu_supply: (300 * Math.random()).toFixed(1),
          // remaining_charging: (500 * Math.random()).toFixed(1),
          battery_soc: (100 * Math.random()).toFixed(1),

          leave_time: childSnapshot.val().leave_time,
        });
      });

      setViewData(listData);
    });

  }

  useEffect(() => {
    makeSampleData2();
  }, []);



  return (
    <div>
      <TableContainer >
        <Table className={classes.table} size="small">
          <TableHead  >
            <TableRow>
              <TableCell width={COLUMN_WIDTH.LABEL} align="center">{i18n.t("chgr")}</TableCell>
              <TableCell width={COLUMN_WIDTH.VGI} align="center">{i18n.t("vgi_yn")}<Typography variant="caption" style={{ paddingLeft: '4px' }}>[Y/N]</Typography></TableCell>
              <TableCell width={COLUMN_WIDTH.CUR_POWER} align="center">{i18n.t("current")}<Typography variant="caption" style={{ paddingLeft: '4px' }}>[kWh]</Typography></TableCell>
              <TableCell width={COLUMN_WIDTH.CUMULATIVE_POWER} align="center">{i18n.t("charged")}<Typography variant="caption" style={{ paddingLeft: '4px' }}>[kWh]</Typography></TableCell>
              <TableCell width={COLUMN_WIDTH.SOC} align="center">{i18n.t("soc")}<Typography variant="caption" style={{ paddingLeft: '2px' }}>[%]</Typography></TableCell>
              <TableCell width={COLUMN_WIDTH.REMAIN_POWER} align="center">{i18n.t("remaining")}<Typography variant="caption" style={{ paddingLeft: '2px' }}>[kWh]</Typography></TableCell>
              <TableCell width={COLUMN_WIDTH.REMAIN_TIME} align="center">{i18n.t("time")}</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {viewData.map(output => (
              <TableRow key={output.label} className={classes.tableRow}>
                <TableCell width={COLUMN_WIDTH.LABEL} align="left"><Typography variant="body2" noWrap>{output.label}</Typography></TableCell>
                <TableCell width={COLUMN_WIDTH.VGI} align="center"><Typography variant="body2" noWrap>{output.VGI}</Typography></TableCell>

                <TableCell width={COLUMN_WIDTH.CUR_POWER}>
                  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                    <Typography variant="body2" noWrap>{numeral(output.cur_supply).format('0,0.0')}</Typography>
                    <Typography className={classes.differenceValue} variant="caption" style={{ paddingLeft: '4px' }}>
                      {output.diff_cur_supply == 0 ? (<span className={classes.grey}><strong>-</strong></span>) :
                        (output.diff_cur_supply > 0 ? (<span className={classes.green}><strong>▲</strong>{numeral(output.diff_cur_supply).format('0,0.0')}</span>)
                          : (<span className={classes.red}><strong>▼</strong>{numeral(output.diff_cur_supply).format('0,0.0')}</span>))}
                    </Typography>
                  </div>
                </TableCell>

                <TableCell width={COLUMN_WIDTH.CUMULATIVE_POWER}>
                  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                    <Typography variant="body2" noWrap>{output.cumulative_supply}</Typography>
                    <Typography className={classes.differenceValue} variant="caption" style={{ paddingLeft: '4px' }}>
                      {output.diff_cumulative == 0 ? (<span className={classes.grey}><strong>-</strong></span>) :
                        (output.diff_cumulative > 0 ? (<span className={classes.green}><strong>▲</strong>{numeral(output.diff_cumulative).format('0,0.0')}</span>)
                          : (<span className={classes.red}><strong>▼</strong>{numeral(output.diff_cumulative).format('0,0.0')}</span>))}
                    </Typography>
                  </div>
                </TableCell>

                <TableCell width={COLUMN_WIDTH.SOC} align="center">
                  <Typography variant="caption" noWrap>{output.battery_soc}</Typography>
                </TableCell>

                <TableCell width={COLUMN_WIDTH.REMAIN_POWER} align='center'>
                  <Typography variant="caption" noWrap={false}>{output.remaining_charging}</Typography>
                </TableCell>

                <TableCell width={COLUMN_WIDTH.REMAIN_TIME} align='center'>
                  <Typography variant="caption" noWrap={false}>{output.leave_time}</Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  )
}

export default CHGRStatusTable;


const useStyles = makeStyles((theme) => ({

  root: {
  },


  chartContainer: {
    // //360px 이상
    // ['@media (min-height:360px)']: {// eslint-disable-line no-useless-computed-key
    //   height: 160,
    // },
    // //360px 이하
    // ['@media (max-height:360px)']: {// eslint-disable-line no-useless-computed-key
    //   height: 120,
    // },
    position: 'relative'
  },

  table:{
    // width:'100%'
  },

  tableRow: {
    height: 40,
  },


  title: {
    fontWeight: 500,
    // paddingLeft: -10,
    // paddingRight: -10,
    marginLeft: -10,
    marginRight: -10,
    // marginBottom: theme.spacing(3),
  },
  differenceValue: {
    // marginRight: theme.spacing(1),
  },
  difference: {
    // marginTop: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
  },
  // label: {
  //   marginLeft: theme.spacing(1),
  // },
  // labelbox: {
  //   margin: theme.spacing(2),
  // },
  // current: {
  //   marginTop: theme.spacing(0.5),
  //   marginRight: theme.spacing(0.5),
  //   // color: theme.palette.secondary.contrastText,
  //   // backgroundColor: theme.palette.secondary.main,
  // },

  grey: {
    // color: theme.palette.grey.light,
    color: 'lightgrey',
    fontWeight: 600,
  },

  green: {
    color: theme.palette.success.light,
    fontWeight: 600,
  },

  red: {
    color: theme.palette.error.light,
    // color: colors.red[400],
    fontWeight: 600,
  }
}));
